import { useQuery } from "@apollo/client/react";

import { GET_MODULE_ATTACHED_GCP_INTEGRATION } from "../gql";
import { GetGcpIntegrationAttachmentGql } from "../types";

const useAttachedGcpIntegration = (moduleId: string | undefined) => {
  const { loading, data } = useQuery<GetGcpIntegrationAttachmentGql>(
    GET_MODULE_ATTACHED_GCP_INTEGRATION,
    {
      variables: {
        moduleId,
      },
      skip: !moduleId,
      fetchPolicy: "no-cache",
    }
  );

  return {
    integration: data?.module?.integrations?.gcp,
    loading,
  };
};

export default useAttachedGcpIntegration;
